import React, { forwardRef } from 'react';

import { navigationMessages } from '../../../../translates/navigationMessages';
import { useIntlReexport } from '../../../hooks/useIntlReexport';
import { useIsMobile } from '../../../hooks/useIsMobile';
import { StudentAudioAssetPlayer } from '../../Audio/editorComponents/StudentAudioAssetPlayer';
import { Question, StartingMessage } from '@ael/core-api';
import { StudentNavigationBar } from '@ael/shared-components-library';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';

interface FullScreenContentModalNavigationProps {
  goToNext?: () => void;
  contentItem: StartingMessage | Question;
  progressDisabled: boolean;
}

export const FullScreenContentModalNavigation = forwardRef(
  (
    { goToNext, progressDisabled, contentItem }: FullScreenContentModalNavigationProps,
    ref: React.Ref<HTMLDivElement>
  ) => {
    const { formatMessage } = useIntlReexport();
    const isMobile = useIsMobile();

    return (
      <StudentNavigationBar
        ref={ref}
        autoProgressStarted={false}
        type="StudentFull"
        goToNext={goToNext}
        progressDisabled={progressDisabled}
      >
        {(autoProgressStarted) => (
          <>
            <StudentNavigationBar.ButtonBox>
              {contentItem.audioAsset ? (
                <StudentAudioAssetPlayer
                  uniqueAudioKey={contentItem.id}
                  audioAsset={contentItem.audioAsset}
                  isMobileDevice={isMobile}
                />
              ) : null}
            </StudentNavigationBar.ButtonBox>
            <StudentNavigationBar.ButtonBox justifyEnd hasLabels>
              {goToNext && (
                <StudentNavigationBar.Button
                  label={formatMessage(navigationMessages.continue)}
                  disabled={progressDisabled}
                  icon={solid('angle-right')}
                  onClick={goToNext}
                  big
                  showLabel={!isMobile}
                  finish
                  displayAutoProgressIndicator={autoProgressStarted}
                />
              )}
            </StudentNavigationBar.ButtonBox>
          </>
        )}
      </StudentNavigationBar>
    );
  }
);
